export default class Tag {
  constructor(descricao, cor) {
    this.descricao = descricao;
    this.cor = cor;
  }
}